<template>
  <Modal :color="ConfigModalsColor" :title="view_product?.name" max_width="800" v-if="view_product"
         footer_color="#f1f1f1" :visible="true" @close="CloseModal">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" lg="6" sm="12" xs="12">
          <img :src="`${ProductImage(view_product)}`" alt="" style="max-width: 100%;">
        </v-col>
        <v-col cols="12" md="6" lg="6" sm="12" xs="12" class="d-flex align-center">
          <div>
            <table class="view-prod-table">
              <tbody>
                <tr v-if="NotPhone">
                  <td>Paper Size</td>
                  <td>{{ view_product.paper_size?.join(', ') }}</td>
                </tr>
                <tr>
                  <td>Manufacturer</td>
                  <td>{{ Brand(view_product.manufacturer_id).name }}</td>
                </tr>
                <tr v-if="NotPhone">
                  <td>Capability</td>
                  <td>{{ view_product.capability }}</td>
                </tr>
                <tr>
                  <td>Model Number</td>
                  <td>{{ view_product.model_number }}</td>
                </tr>
                <tr v-if="NotPhone">
                  <td>Color/Monochrome</td>
                  <td>{{ view_product.copier_color }}</td>
                </tr>
                <tr v-if="view_product.speed_color && NotPhone">
                  <td>Speed (Color)</td>
                  <td>{{ view_product.speed_color }} PPM</td>
                </tr>
                <tr v-if="view_product.speed_black && NotPhone">
                  <td>Speed (Mono)</td>
                  <td>{{ view_product.speed_black }} PPM</td>
                </tr>
                <tr v-if="NotPhone">
                  <td>Connectivity</td>
                  <td>{{ view_product.connectivity?.join(', ') }}</td>
                </tr>
                <tr v-if="NotPhone">
                  <td>Paper Capacity</td>
                  <td>{{ view_product.paper_capacity }}</td>
                </tr>
                <tr v-if="NotPhone">
                  <td>Form Factor</td>
                  <td>{{ view_product.form_factor }}</td>
                </tr>
                <tr v-if="NotPhone">
                  <td>Usage Class</td>
                  <td>{{ view_product.usage_class }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>
      <div class="product-description pa-3 mt-5 rounded" v-html="view_product.description"></div>
    </v-card-text>
    <template v-slot:footer>
      <v-spacer/>
      <v-btn class="mt-1 mb-1 ml-1" @click="Configure" :color="ConfigElementsColor" prepend-icon="mdi-printer">
        Configure
      </v-btn>
      <v-spacer/>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import Modal from "@/components/misc/Modal.vue"

const store = useGlobalsStore()
const {
  view_product,
  manufacturers,
  ConfigModalsColor,
  ConfigElementsColor
} = storeToRefs(store)

const NotPhone = computed(() => {
  if (!view_product.value) return false
  return view_product.value.printer_category.toLowerCase() !== 'ip phone'
})

function Brand(id: any) {
  return manufacturers.value.find((b: any) => b.id == id) || { name: '' }
}

function CloseModal() {
  store.SetState('view_product', null)
}

function Configure() {
  if (view_product.value) {
    store.SetSelectedCopier(view_product.value)
    store.SetState('configurator', true)
    store.SetState('cart_modal', false)
    CloseModal()
  }
}

// Store helpers
const ProductImage = store.ProductImage
</script>

<style>
.view-prod-table {
  & th,
  & td {
    font-family: Quicksand, Roboto, sans-serif;
  }

  & {
    width: 100%;
    border-collapse: collapse;
  }

  & tr {
    & td:first-child {
      padding-right: 20px;
    }
  }

  & tr td {
    padding: 5px 10px;
    border: 1px solid #d1d1d1;
    border-right: none;
    border-left: none;
  }
}

.product-description {
  font-family: Quicksand, Roboto, sans-serif;

  & ul li p {
    display: inline;
  }
}

.product-description ul {
  margin-left: 18px;
}
</style>
